// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__YhTn+","errorCode":"NotFound_errorCode__D8WmS","text":"NotFound_text__EcWFE","image":"NotFound_image__NR7nB"};